import { DOM } from 'react';
/**
 * @param props
 * @returns {any}
 * @constructor
 */
export function DangerousHtml(props) {
    let newProps = Object.assign({}, props);
    newProps.dangerouslySetInnerHTML = {
        __html: props.children
    };
    delete newProps.children;
    var type = newProps.type;
    delete newProps.type;
    if (!newProps.className) {
        newProps.className = 'dangerousHtml';
    }
    else {
        newProps.className += ' dangerousHtml';
    }
    return DOM[type || 'span'](newProps);
}
